import { useState } from "preact/hooks";

export default function useCopyToClipboard(delay = 1500) {
    const [copied, setCopied] = useState(false);

    const copyToClipboard = async (value) => {
        if (!value) return;

        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);
            setTimeout(() => setCopied(false), delay);
        } catch {
            // Clipboard API is unavailable in non-HTTPS contexts — fail silently.
            setCopied(false);
        }
    };

    return { copied, copyToClipboard };
}
